import logo from "../assets/logo.png";
import {Link} from "react-router-dom";


const XDLoadoutLogo = ({height, style}) => {
    return <Link to='/'><img src={logo} height={height} style={style} alt='XDLoadout logo'/></Link>
}

export default XDLoadoutLogo